module.exports = __webpack_public_path__ + "assets/img/1.d926a0ac.jpg";